<template>
    <div class="content">
        <Header/>
        <div class="wrap">
            <!--<el-scrollbar style="height: 100%">-->
                <Menu/>
            <!--</el-scrollbar>-->
            <div class="page">
                <div class="page-wrap">
                    <HeadTop v-if="$route.meta.length !== 0"/>
                    <div style="margin: 0 20px;">
                        <transition name="fade-transform" mode="out-in">
                            <router-view :key="this.$route.path"></router-view>
                        </transition>
                    </div>
                </div>
                <!-- <el-backtop target=".page-component__scroll .el-scrollbar__wrap"></el-backtop> -->
            </div>
        </div>
    </div>

</template>

<script>
    import Header from '@/pages/head/head';
    import Menu from '@/pages/menu/menu';
    import HomeDetail from './home_detail';
    import HeadTop from '@/pages/head/head_top';
    import elBacktop from 'element-ui';

    export default {
        components: {
            Header,
            Menu,
            HomeDetail,
            HeadTop
        },  
    }
</script>

<style lang="scss" scoped>
    @import "@/styles/transition.scss";

    .el-popup-parent--hidden {
        .fixed-header {
            padding-right: 15px;
        }
    }
    .wrap{
        position: absolute;
        display: flex;
        justify-content: space-around;
        top: 7.21%;
        // margin-top: 7.21%;
        width: 100%;
        height:calc(100% - 7.21%);
        background: #f3fafb;
    }
    .page {
        height: 100%;
        overflow: auto;
        padding: 20px;
        box-sizing: border-box;
        // position: absolute;
        width: calc(100% - 13.54%);
        right: 0;
        // background: #f3fafb;
        box-sizing: border-box;
    }
    .page-wrap{
        // margin: 0 20px;
        /*height: 650px;*/
        /*padding: 20px 20px 0 20px;*/
        padding-bottom: 20px;
        background-color: #ffffff;
        // box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.1) inset;
    }

    .content {
        background-color: #f3fafb;
    }
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue